import Blog from './index.vue'

export default Blog